import { Image } from "antd";
import React, { memo, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPaperById } from "store/bailiff/(default)/paper/default_paper.action";
import { defaultPaperSelectedSelector } from "store/bailiff/(default)/paper/default_paper.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const KycDocument = memo(() => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [url, setUrl] = useState(null);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const selected = useSelector(defaultPaperSelectedSelector);
  const fileName = selected?.fileName;
  const client = selected?.client;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (fileName && client) {
      dispatch(
        getPaperById({ fileName, client }, (res) => {
          if (res) {
            setUrl(res);
          }
        })
      );
    }
  }, [fileName, client, dispatch]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!url)
    return (
      <div
        style={{
          width: "100%",
          height: 400,
          borderRadius: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f1f1f1",
          border: "2px dashed rgba(0,0,0,0.3)",
          overflow: "hidden",
        }}
      >
        <p>Ảnh không load được</p>
      </div>
    );
  return (
    <div
      style={{
        width: "100%",
        height: 400,
        borderRadius: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f1f1f1",
        overflow: "hidden",
        border: "2px dashed rgba(0,0,0,0.3)",
      }}
    >
      <Image
        src={url}
        style={{
          width: "100%",
          height: "auto",
          borderRadius: 10,
        }}
      />
    </div>
  );
});
export default KycDocument;
